import {Oktoberfest} from "../Oktoberfest";
import {TimelineLite, TweenLite} from "gsap";
import {OktoberfestReelView} from "../reels/OktoberfestReelView";
import {OktoberfestSound} from "../sound/OktoberfestSound";
import {Layers, OktoberfestLayers} from "./OktoberfestLayers";

export class OktoberfestPretzelPartyView extends PIXI.Container {
    private _pretzelBlinks: PIXI.Sprite[][];
    private _blinkTimeline: TimelineLite;
    private _blinkContainer: PIXI.Container;

    constructor() {
        super();
        this.init();
        this.visible = false;
        OktoberfestLayers.getLayer(Layers.PRETZEL_PARTY_WIN)!.addChild(this);
    }

    public playBlinkAnimations(lastStoppedReel: number): TimelineLite {
        this.visible = true;
        this.addChild(this._blinkContainer);
        this._blinkTimeline = new TimelineLite({
            paused: true, onComplete: () => {
            }
        });
        const firstReelPos: number = OktoberfestReelView.REEL_AREAS[0].x;
        const offsetX: number = -13;
        const offsetY: number = 23;
        let reelIdXPos: number[] = [0, OktoberfestReelView.REEL_AREAS[1].x - firstReelPos, OktoberfestReelView.REEL_AREAS[2].x - firstReelPos, OktoberfestReelView.REEL_AREAS[3].x - firstReelPos, OktoberfestReelView.REEL_AREAS[4].x - firstReelPos];
        let overlays: string[][] = Oktoberfest.model.parsedGameData.overlayWilds;
        for (let reelId: number = 0; reelId <= lastStoppedReel; reelId++) {
            for (let symId: number = 0; symId < overlays[reelId].length; symId++) {
                if (overlays[reelId][symId] === "W") {
                    this._pretzelBlinks[reelId][symId].x = reelIdXPos[reelId] + offsetX;
                    this._pretzelBlinks[reelId][symId].y = Oktoberfest.reels[reelId].getSymbol(symId).position.y + offsetY;
                    this._blinkTimeline.add([
                        new TweenLite(this._pretzelBlinks[reelId][symId], 0.5, {alpha: 1}),
                        () => {
                            OktoberfestSound.soundPlayer.playTrack({name: OktoberfestSound.SOUND_NAME_PM_WILD_LIGHTS_UP})
                        }
                    ]);
                    this._blinkTimeline.add([
                        new TweenLite(this._pretzelBlinks[reelId][symId], 0.5, {alpha: 0}),
                    ]);
                }
            }
        }

        this._blinkTimeline.totalDuration(0.6);
        this._blinkTimeline.play(0);
        return this._blinkTimeline;
    }

    private init(): void {
        this._blinkContainer = new PIXI.Container();
        let reelNum: number = 5;
        let symbolsNum: number = 3;
        this._pretzelBlinks = [];
        for (let i: number = 0; i < reelNum; i++) {
            let blinkOnReel: PIXI.Sprite[] = [];
            for (let j: number = 0; j < symbolsNum; j++) {
                blinkOnReel.push(this.createBlinkGraphics(i, j));
            }
            this._pretzelBlinks.push(blinkOnReel);
        }
    }

    private createBlinkGraphics(reelId: number, symId: number): PIXI.Sprite {
        let blinkOverlay: PIXI.Sprite = new PIXI.Sprite(Oktoberfest.assetLoader.getTextures("W/W")[0]);
        blinkOverlay.alpha = 0;
        blinkOverlay.blendMode = PIXI.BLEND_MODES.ADD;
        this._blinkContainer.addChild(blinkOverlay);
        return blinkOverlay;
    }
}
